import Nav from "../components/Nav";
import { Box } from "@mui/material";

export default function Docs() {
    return (
        <div>
            <Nav />
            <Box
                sx={{
                    mt: { xs: 7, sm: 8 },
                    width: '100%',
                    height: 64,
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: {
                        xs: 2,
                        sm: 3,
                    },
                    textAlign: 'center',
                }}
            >
                docs here
            </Box>
        </div>
    );
}